module.exports = __webpack_public_path__ + "static/media/1_9.4d7dec97.png";